/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "4a308b128ec7e6efcce87802f159df4394170471";
